"use client";
import * as React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { wrap } from "popmotion";
import AvailableClassCard from "./AvailableClassCard";
import PrivateDateCard from "./PrivateDateCard";
import { CousrsDetailsType } from "@/app/types";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {

    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};

type DatesCardsPropsType={
  course:CousrsDetailsType
}
function MobileDatesSlider({course}:DatesCardsPropsType) {
  const [[page, direction], setPage] = useState([12, 0]);

  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  const dateIndex = wrap(0, 2, page);

  const DateTypes = (changeActive: any) => [
    <div className={`flex-1 flex  gap-10 `} key={1}>
      <PrivateDateCard course={course}/>
      <SilderBtn color="#F2E30C" changeActive={() => changeActive(-1)} />
    </div>,
    <div className={`flex-1 flex  gap-10`} key={2}>
      <SilderBtn
        silde="right"
        color={course?.color} 
        changeActive={() => changeActive(1)}
      />
      <AvailableClassCard  course={course}/>
    </div>,
  ];

  return (
    <AnimatePresence initial={false} custom={direction}>
      <div className="overflow-hidden p-5 -mx-5">
        {" "}
        <motion.div
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          className="flex "
          exit="exit"
          transition={{
            x: { type: "tween", duration: 0.2 },
            opacity: { duration: 0.2 },
          }}
        >
          <div className={`flex-1 flex  `} key={dateIndex}>
            {DateTypes(paginate)[dateIndex]}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default MobileDatesSlider;

const SilderBtn = ({
  changeActive,
  color,
  silde = "left",
}: {
  changeActive: () => void;
  color?: string;
  silde?: "left" | "right";
}) => {
  return (
    <div
      className={`w-[70px]  bg-secondary rounded-[35px] flex ${
        silde == "left" ? "flex-row" : "flex-row-reverse"
      } items-center justify-center`}
      onClick={changeActive}
      style={{ background: color }}
    >
      <p
        className="text-[18px] font-bold rotate-180"
        style={{ writingMode: "vertical-lr" }}
      >
        Available Classes
      </p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.109"
        height="8.377"
        viewBox="0 0 15.109 8.377"
        className={`${silde == "left" ? "rotate-90" : "-rotate-90"}   `}
      >
        <path
          id="Path_49625"
          data-name="Path 49625"
          d="M-14235-22930l5.834,5.359,5.742-5.359"
          transform="translate(-14221.657 -22923.391) rotate(180)"
          fill="none"
          stroke={"#220859"}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
      </svg>
    </div>
  );
};
